<template>
  <div class="home-box">
    <h2 class="gray_dk--text">Reports</h2>
    <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
      <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-row v-if="!loading">
      <v-col cols="12" xs="12" md="12" class="h-100">

      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row v-if="!loading">
      <v-col cols="12" xs="12" md="12" class="h-100">
        <h3 class="orange--text">
          Activity Reports
        </h3>
      </v-col>
    </v-row>
    <v-row v-if="!loading">
      <v-col cols="12" xs="12" md="12" class="h-100">
        <ActivityClubWiseReport></ActivityClubWiseReport>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row v-if="!loading">
      <v-col cols="12" xs="12" md="12" class="h-100">
        <h3 class="orange--text">
          Service Project Reports
        </h3>
      </v-col>
    </v-row>
    <v-row v-if="!loading">
      <v-col cols="12" xs="12" md="12" class="h-100">
        <ThemeWiseReport></ThemeWiseReport>
      </v-col>
    </v-row>

    <v-row v-if="!loading">
      <v-col cols="12" xs="12" md="12" class="h-100">
        <ProjectClubWiseReport></ProjectClubWiseReport>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

import ActivityClubWiseReport from "../../components/activities/reports/ActivityClubWiseReport";
import ThemeWiseReport from "../../components/service-projects/reports/ThemeWiseReport";
import ProjectClubWiseReport from "../../components/service-projects/reports/ProjectClubWiseReport";

export default {
  name: "Projects",
  components: {
    ActivityClubWiseReport,
    ThemeWiseReport,
    ProjectClubWiseReport
  },
  data: function () {
    return {
      loading: false,
      role: localStorage.getItem("role"),
      statsNotFound: require("@/assets/img/stats_empty.png"),

    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },
  mounted() { },

  watch: {},

  methods: {
  },
};
</script>
